var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-flow"},[_c('y-checkbox',{on:{"change":_vm.flowChange},model:{value:(_vm.insufficientFlow),callback:function ($$v) {_vm.insufficientFlow=$$v},expression:"insufficientFlow"}},[_vm._v(" Insufficient flow ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }